import { Link, NavLink } from "react-router-dom";

import SignOutButton from "../auth/SignOutButton";
import { cn } from "../lib/cn";
import Logo from "./ui/Logo";

/** The header bar, as the eval dashboard draws it: the mark, the one view, and the way out. */
export default function AppHeader() {
  return (
    <div className="mx-auto max-w-page px-6 pt-4">
      <header className="card flex h-16 items-center gap-8 px-8">
        <Link to="/sessions" aria-label="Jiva Admin — sessions" className="text-ink-strong">
          <Logo className="h-[18px] w-[52px] shrink-0" />
        </Link>

        <nav className="flex items-center gap-1" aria-label="Views">
          <NavLink
            to="/sessions"
            className={({ isActive }) =>
              cn(
                "flex h-[34px] items-center rounded-control px-4 text-tab transition-colors",
                isActive ? "bg-surface-muted text-ink-2" : "text-ink-faint hover:text-ink-2",
              )
            }
          >
            Sessions
          </NavLink>
        </nav>

        <SignOutButton className="ml-auto" />
      </header>
    </div>
  );
}
